import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Pagination from "../../commanPage/paginationUi/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { getAllCollectionHistory } from "../../../redux/action/wallet";
import TableLoader from "../../commanPage/loader/TableLoader";
import { capitalizeFirstLetter, convertTo12HourFormat } from "../../../helper/helpers";

function CollectionHistory({ searchData }) {
  const dispatch = useDispatch();
  const totalNumberRow = 100;
  const [currentPage, setCurrentPage] = useState(0);
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [initialSearchData, setInitialSearchData] = useState([]);
  const [allCollectionHistory, setAllCollectionHistory] = useState([]);
  const { collectionHistory, collectionHistoryLoading } = useSelector((state) => state.withdrawalRequest);

  useEffect(() => {
    dispatch(getAllCollectionHistory());
  }, [dispatch])

  useEffect(() => {
    setInitialSearchData(collectionHistory);
    setAllCollectionHistory(collectionHistory);
  }, [collectionHistory]);

  useEffect(() => {
    if (searchData?.trim()) {
      const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
      };

      const filteredData = initialSearchData?.filter((item) =>
        [
          "organization.organizationName",
          "payerName",
          "payerAccNumber",
          "status",
        ].some((field) =>
          getNestedValue(item, field)?.toLowerCase()?.includes(searchData?.trim()?.toLowerCase())
        )
      );

      setAllCollectionHistory(filteredData);
    } else {
      setAllCollectionHistory(initialSearchData);
    }
  }, [searchData, initialSearchData]);

  if (collectionHistoryLoading) {
    return <div className="valign-wrapper justify-center cover white mt-1">
      <TableLoader
        headerData={[
          "Organisation Name",
          "Bank Name",
          "Account No",
          "Date",
          "Amount",
          "Actions",
        ]}
      />
    </div>
  }

  return (
    <>
      <div className={`mt-1 ${!isTablet && "table-container-style"}`}>
        <table
          className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
            } `}
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Organisation Name</th>
              <th>Bank Name</th>
              <th>Account No</th>
              <th>IFSC code</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody className="white">
            {allCollectionHistory
              ?.slice(currentPage, currentPage + totalNumberRow)
              ?.map((items, index) => (
                <tr className="white black-text" key={items?._id}>
                  <td>
                    {items.status === "success" ? (
                      <img
                        style={{ width: "30px" }}
                        src={`${process.env.PUBLIC_URL}/icons/${items.amount < 0
                          ? "wallet-minus.svg"
                          : "wallet-add.svg"
                          }`}
                        alt="Icon"
                      />
                    ) : (
                      <img
                        style={{ width: "30px" }}
                        src={`${process.env.PUBLIC_URL}/icons/wallet-pending.svg`}
                        alt="Icon"
                      />
                    )}
                  </td>
                  <td>{items?.organization?.organizationName}</td>
                  <td>{items?.payerName}</td>
                  <td>{items?.payerAccNumber}</td>
                  <td>{items?.payerBankIFSC}</td>
                  <td>
                    <span>
                      {new Date(items?.updatedAt).toLocaleDateString("en-GB")}
                    </span>
                    <span> {convertTo12HourFormat(items?.updatedAt)}</span>
                  </td>
                  <td>{Math.abs(items.amount)}</td>
                  <td>
                    <span
                      style={{
                        color:
                          items?.status === "success"
                            ? "green"
                            : items?.status === "rejected"
                              ? "red"
                              : items?.status === "failed"
                                ? "red"
                                : items?.status === "completed"
                                  ? "purple"
                                  : "orange",
                      }}
                    >
                      {capitalizeFirstLetter(items.status)}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {(!allCollectionHistory || allCollectionHistory?.length === 0) && (
          <div className="full-width column grey-text p-1 noItems-height flex align-center justify-center ">
            <span className="material-symbols-outlined large-size ">
              receipt_long
            </span>
            <p>No data found.</p>
          </div>
        )}
      </div>

      <Pagination
        Data={allCollectionHistory || []}
        totalNumberRow={totalNumberRow}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
}

export default CollectionHistory;
